import { Eye, X } from 'lucide-react';

interface PreviewBannerProps {
  formTitle: string;
  revisionVersion: number;
  isDraft: boolean;
  onClose?: () => void;
}

export default function PreviewBanner({
  formTitle,
  revisionVersion,
  isDraft,
  onClose,
}: PreviewBannerProps) {
  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-amber-500 text-white shadow-lg">
      <div className="max-w-5xl mx-auto px-6 py-4">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          {/* Left section - Preview indicator */}
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2 bg-white/20 px-3 py-1.5 rounded-full">
              <Eye className="h-4 w-4" />
              <span className="font-semibold text-sm uppercase tracking-wide">
                Preview
              </span>
            </div>
            <div className="flex flex-col">
              <span className="font-medium truncate max-w-[200px] sm:max-w-[300px]">
                {formTitle}
              </span>
              <span className="text-xs text-amber-100">
                {isDraft ? 'Draft' : 'Published'} &middot; Version{' '}
                {revisionVersion}
              </span>
            </div>
          </div>

          {/* Right section - Info and close */}
          <div className="flex items-center gap-4">
            <span className="text-sm text-amber-100 hidden md:block">
              Responses will not be saved
            </span>
            {onClose && (
              <button
                type="button"
                onClick={onClose}
                aria-label="Close preview"
                className="flex items-center gap-2 bg-white/20 hover:bg-white/30 px-4 py-2 rounded-lg text-sm font-medium transition-colors"
              >
                <X className="h-4 w-4" aria-hidden="true" />
                <span className="hidden sm:inline">Close</span>
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
